import { AfterViewInit, Directive, ElementRef, Input, SimpleChanges } from "@angular/core";
import { Web3Service } from "app/services/web3/web3.service";
import { formatNum } from "../utils/number.util";

@Directive({
    selector: "[from-wei]"
})

export class FromWeiDirective implements AfterViewInit {

    @Input() wei: string;
    @Input() formatNumber: boolean = true; //if you want exact value not formatted set this false

    constructor(
        private elementRef: ElementRef,
        private web3Service: Web3Service
    ) { }

    ngAfterViewInit(): void {
        if (this.wei) {
            const htmlElement = this.elementRef.nativeElement as HTMLElement;
            if (this.formatNumber) htmlElement.textContent = formatNum(this.web3Service.fromWeiFloat(this.wei));
            else htmlElement.textContent = this.web3Service.fromWeiFloat(this.wei) + '';
        }
    }

}